// lib
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Accordion, AccordionDetails, AccordionSummary, IconButton, List } from "@material-ui/core";
import { ExpandMore, Settings } from "@material-ui/icons";

import ColoredCheckbox from "./ColoredCheckbox";

const Section = ({
  defaultExpanded,
  children,
  title,
  level,
  deferClick,
  checked,
  secondaryAction,
  appendClassName,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const controlExpand = Boolean(deferClick);
  const handleSecondaryAction = (e) => {
    e.stopPropagation();
    secondaryAction();
  };
  let className = secondaryAction ? "panel-summary with-secondary-action" : "panel-summary";
  className = deferClick ? `${className} with-check` : className;

  const stopPropagation = (e) => e.stopPropagation();

  const handleClick = (e) => {
    e.stopPropagation();
    const newExpanded = deferClick();
    setExpanded(newExpanded);
  };

  const handleChange = (e, isExpanded) => {
    setExpanded(isExpanded);
  };

  const accordionProps = controlExpand
    ? {
        expanded,
        onChange: handleChange,
      }
    : { defaultExpanded };

  return (
    <Accordion className={`level-${level} panel ${appendClassName}`} {...accordionProps}>
      <AccordionSummary className={className} expandIcon={<ExpandMore />}>
        {controlExpand && (
          <div className="checkbox-root">
            <div className="checkbox-shadow" />

            <ColoredCheckbox
              color="#bbb"
              checked={checked}
              onClick={handleClick}
              onFocus={stopPropagation}
              aria-label="check-category"
            />
          </div>
        )}
        <div className="panel-summary-header">{title}</div>
        {Boolean(secondaryAction) && (
          <IconButton className="secondary-action" onClick={handleSecondaryAction}>
            <Settings />
          </IconButton>
        )}
      </AccordionSummary>
      <AccordionDetails className="panel-details">
        <List dense>{children}</List>
      </AccordionDetails>
    </Accordion>
  );
};

Section.propTypes = {
  // parent props
  children: PropTypes.node.isRequired,
  defaultExpanded: PropTypes.bool.isRequired,
  title: PropTypes.node.isRequired,
  level: PropTypes.number,
  secondaryAction: PropTypes.func,
  deferClick: PropTypes.func,
  checked: PropTypes.bool,
  appendClassName: PropTypes.string,
};

Section.defaultProps = {
  level: 0,
  secondaryAction: null,
  deferClick: null,
  checked: false,
  appendClassName: "",
};

export default Section;
